import { IeLynxObject } from "../../common/models/eLynxObject";
import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import { IGroupViewState, IObjectViewState, ITagViewState } from "../../services/state-data-service/Models";
import StateDataService from "../../services/state-data-service/StateDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type ObjectViewStateType = IGroupViewState | IObjectViewState | ITagViewState | undefined;

export type ObjectViewStateParameters = {
    customerID: number,
    groupID: number,
    contextObject?: IeLynxObject,
} & BaseUseQueryParameters<ObjectViewStateType | undefined>;

export function useObjectViewState({
    customerID,
    groupID,
    contextObject,
    offline,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: ObjectViewStateParameters) {
    return useQuery<ObjectViewStateType, RestError>(
        keys.object(customerID, groupID, contextObject, offline),
        ({ signal }) => {
            return contextObject
                ? StateDataService.getObjectViewState(customerID,
                    groupID,
                    contextObject as IeLynxObject,
                    offline ?? false,
                    signal)
                : Promise.resolve(
                    undefined
                );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds  * 1000 : false
        }
    );
}
